module.exports = __webpack_public_path__ + "static/signup_graphic-0db022f57a558e74f6531d684913c42b.svg";